import { initializeApp } from "firebase/app";
import {
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  TwitterAuthProvider,
  signInWithPopup
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDiIVMiHzjJCd8rgJvObHHrbvWTb0SVoJw",
  authDomain: "car-rental-8647e.firebaseapp.com",
  projectId: "car-rental-8647e",
  storageBucket: "car-rental-8647e.firebasestorage.app",
  messagingSenderId: "678566928837",
  appId: "1:678566928837:web:4bfacc65399339f676ebac",
  measurementId: "G-JEJ05D5G48"
};

initializeApp(firebaseConfig);
export const auth = getAuth();
export const google = new GoogleAuthProvider();
export const facebook = new FacebookAuthProvider();
export const twitter = new TwitterAuthProvider();


